define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../shared/dataLogs", "../../models/PhoneNumberModel", "../../models/UserContext", "./phoneNumberActions"], function (require, exports, $, ko, log, urls_1, tools, DataLogs, PhoneNumberModel, UserContext, PhoneNumberActions) {
    "use strict";
    var PhoneNumberDetails = /** @class */ (function () {
        function PhoneNumberDetails() {
            this.editPhoneModel = ko.observable(new PhoneNumberModel());
            this.userCanDeleteE911 = ko.observable(UserContext.hasAccess("Admin,E911.Delete"));
            this.phoneActions = new PhoneNumberActions();
            var self = this;
        }
        PhoneNumberDetails.prototype.init = function (id) {
            var self = this;
            self.phoneActions.savePhoneCallback = function (data) {
                self.editPhoneModel(new PhoneNumberModel(data));
                if (self.dataLogs) {
                    self.dataLogs.refreshLogs();
                }
            };
            tools.ajaxGet({
                url: urls_1.urls.getPhoneNumberById,
                data: { id: id },
                success: function (result) {
                    if (result.Success) {
                        self.editPhoneModel(new PhoneNumberModel(result.Data));
                        self.editPhoneModel().NumberEditReadonly(true);
                        if (self.editPhoneModel().CustomerId()) {
                            self.editPhoneModel().CustomerEditReadonly(true);
                        }
                        else {
                            self.editPhoneModel().CustomerEditReadonly(false);
                        }
                        $("#ko-main-content").on("click", ".btn-edit", function (event) {
                            self.phoneActions.editPhoneNumber(self.editPhoneModel().Id(), self.editPhoneModel().Number());
                            event.preventDefault();
                        });
                        ko.applyBindings(self, document.getElementById("ko-main-content"));
                        $("#contextLoader").hide();
                        $("#mainContext").show();
                        self.initLogs(id);
                    }
                    else {
                        log.error(result.Error);
                    }
                }
            });
        };
        PhoneNumberDetails.prototype.initLogs = function (id) {
            var self = this;
            if (UserContext.hasAccess("Admin,PhoneNumbers.Logs")) {
                self.dataLogs = new DataLogs("PhoneNumber", id);
                self.dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return PhoneNumberDetails;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith(urls_1.urls.phoneNumberDetails)) {
            var id = urls_1.urls.getIdFromQueryString();
            if (id <= 0) {
                id = urls_1.urls.getIdFromUrl();
            }
            log.log("Initialize Phone Number Details id: ".concat(id));
            $(function () {
                (new PhoneNumberDetails()).init(id);
            });
        }
    }, 0);
    return PhoneNumberDetails;
});
//# sourceMappingURL=phoneNumberDetails.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/phoneNumbers/phoneNumberDetails.js
// module id = 210
// module chunks = 2